const routes = Object.freeze({
    signIn: 'sign-in',
    register: 'register',
    sso: 'single-sign-on',
    consent: 'consent',
    device: 'device',
    resetPassword: 'reset-password',
    identifierSignIn: 'identifier-sign-in',
    identifierRegister: 'identifier-register',
    switchAccount: 'switch-account',
    oneTimeToken: 'one-time-token',
    accountSuspended: 'account-suspended',
    trustedDevice: 'trusted-device',
    /** Pure step-up: an authenticated session pins the subject and only the missing assurance is asked. */
    stepUp: 'step-up',
});
export const experience = Object.freeze({
    routes,
});
/** `postMessage` sender tag from admin Console sign-in experience live preview. */
export const signInExperiencePreviewMessageSender = 'ac_preview';
